import { Pipe, PipeTransform } from '@angular/core';
import { round } from '../utils/round';

@Pipe({
  name: 'round',
  standalone: true,
})
export class RoundPipe implements PipeTransform {
  transform(value: number | null | undefined, decimals: number = 0): string {
    if (value == null || isNaN(value)) {
      return '';
    }
    return round(value, decimals);
  }
}
